import { Typography } from "@mui/material";

// Error message component
const CommonErrorMessage = ( { text } ) => {
  if ( !text ) return null;

  return (
    <Typography color="error" variant="caption" sx={ { textAlign: 'center', display: 'block' } }>
      { text }
    </Typography>
  );
};


export default CommonErrorMessage;